import React, { useEffect, useRef, useState, useMemo } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material'

function StatusDialog({
  open,
  onClose,
  value: valueProp,
  statusList = [],
  label = 'Statut',
  title = 'Modifier Statut',
  idSuffix = '', // optional suffix for unique label IDs
  ...other
}) {
  const [value, setValue] = useState(valueProp)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setValue(valueProp)
    }
  }, [valueProp, open])

  const handleCancel = () => {
    onClose()
  }

  const handleConfirm = () => {
    onClose(value)
  }

  const handleEntering = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const filteredStatus = useMemo(() => {
    return statusList?.filter((item) => item.is_list).sort((a, b) => a.order - b.order)
  }, [statusList])

  const labelId = `status-select-label${idSuffix}`

  return (
    <Dialog
      open={open}
      maxWidth='xs'
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      TransitionProps={{ onEntering: handleEntering }}
      {...other}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth variant='outlined' margin='normal'>
          <InputLabel id={labelId}>{label}</InputLabel>
          <Select
            labelId={labelId}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            label={label}
            inputRef={inputRef}
          >
            {filteredStatus.map((item) => (
              <MenuItem key={item.status_code} value={item.status_code}>
                {item.status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Annuler</Button>
        <Button onClick={handleConfirm}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default StatusDialog
